import { Box, Container, Typography, Button, Stack } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { PATH_NAME } from "../../../configs/pathName";
import colorConfigs from "../../../configs/colorConfigs";
import { typo } from "../../../assets/fonts/font";

const GuestPayment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { transactionId } = location.state || {};

  const handleContinueShopping = () => {
    // Clear guest order from localStorage if needed
    localStorage.removeItem('guestOrder');
    navigate(PATH_NAME.ALLPRODUCTS);
  };

  return (
    <Box sx={{ background: colorConfigs.secondary, minHeight: "100vh" }}>
      <Container sx={{ py: 8 }}>
        <Box
          sx={{
            backgroundColor: "var(--color-white)",
            borderRadius: "16px",
            padding: "2rem",
            textAlign: "center",
            boxShadow: "0px 4px 12px var(--color-shadow-10)",
          }}
        >
          <Typography
            sx={{ ...typo.title, color: colorConfigs.primary, mb: 2 }}
          >
            Thank You For Your Order!
          </Typography>
          
          <Typography sx={{ ...typo.bodyContent, mb: 3 }}>
            Your order has been placed successfully. Here's your transaction ID:
          </Typography>
          
          <Typography
            sx={{
              ...typo.title,
              color: colorConfigs.tertiary,
              mb: 4,
              wordBreak: "break-word",
            }}
          >
            {transactionId}
          </Typography>
          
          <Typography sx={{ ...typo.bodyContent, mb: 4 }}>
            We've sent a confirmation email with your order details. 
          </Typography>
          
          <Stack direction="row" justifyContent="center" spacing={2}>
            <Button
              variant="contained"
              sx={{
                borderRadius:30,
                backgroundColor: colorConfigs.quaternary,
                borderColor: colorConfigs.tertiary,
                borderWidth:1,
                borderStyle:'solid',
                "&:hover": {
                  backgroundColor: colorConfigs.primary,
                },
              }}
              onClick={handleContinueShopping}
            >
              <Typography sx={{...typo.bodyContent}}>Continue Shopping</Typography>
            </Button>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default GuestPayment;